module.exports = __webpack_public_path__ + "static/media/coin.555a0bb4.png";